import $ from "jquery";

$(function () {
  $(".artist-popup").click(function () {
    window.open(
      this.href,
      $(this).data("id"),
      "height=700,width=1000,scrollbars=1,resizable=1"
    );
    return false;
  });
});
